<!--  -->
<template>
  <div class=''>
    <h2> 账户信息</h2>
    <el-form ref="FormRef" :model="Form" label-width="100px">
      <!-- :rules="editFormRules" -->
      <el-form-item label="用户名" prop="username" style="font-weight:bold;">
        <el-input v-model="Form.username" disabled style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" style="font-weight:bold">
        <el-input v-model="Form.mobile" disabled style="width: 50%;"></el-input>
        <!-- <el-button style="color:dodgerblue" type="text" @click="dialogPhoneEdit = true">&nbsp;&nbsp;修改</el-button> -->
      </el-form-item>
      <!-- <el-form-item label="邮箱" prop="email" style="font-weight:bold">
        <el-input v-model="Form.email" disabled style="width: 50%;"></el-input>
        <el-button style="color:dodgerblue" type="text">&nbsp;&nbsp;修改</el-button>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button type="primary" @click="dialogPSW = true">修改密码</el-button>
      </el-form-item> -->
    </el-form>



  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
//这里存放数据
    return {
      Form: {
        username: "",
        mobile: "",
        email: "",
        code: "",
        randomMobile: "",
      },
    };
  },
//监听属性 类似于data概念
  computed: {},
//监控data中的数据变化
  watch: {},
//方法集合
  methods: {
    getInfo() {
      this.$http({
        url: this.$http.adornUrl("/enterprise/info/app/getBasicInfoWomenBabyBigScreen?eid=" + this.eid),
        method: "post",
      }).then(({ data }) => {
        if (data && data.code === 0) {
          console.log("看看数据");
          console.log(data);
          var information = data.detail_data
          console.log(information)
          this.Form.username = information.manager_name
          // this.Form.email = information.email
          this.Form.mobile = information.manager_phone
        } else {
          // this.getCaptcha()
          this.$message.error(data.msg);
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          // eslint-disable-next-line no-unused-vars
          .then(_ => {
            done();
          })
          // eslint-disable-next-line no-unused-vars
          .catch(_ => {});
    }
  },
//生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.eid = this.$store.state.health_station.eid
    
  },
//生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getInfo()
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>

</style>
